<template>
    <div id="app">
        <Header v-if="this.$router.path != '/login' || this.$router.path != '/logout'"/>
        <Sidebar v-if="this.$router.path != '/login' || this.$router.path != '/logout'"/>
        <div class="main-content">
            <div class="panel-content">
                <transition name="fade" enter-active-class="animated fadeIn" leave-active-class="fadeOut">
                    <router-view/>
                </transition>
            </div>
        </div>
        <vue-progress-bar></vue-progress-bar>
    </div>
</template>
<script>
    import Sidebar from "./components/layouts/Sidebar";
    import Header from "./components/layouts/Header";

    export default {
        components: {
            Sidebar,
            Header
        },
        data() {
            return {
                render: localStorage.getItem('access_token') !== null ? true : false
            }
        },
    };
</script>

<style lang="scss">
    @import "@/assets/css/index.scss";

    .main-content {
        position: relative;
    }
</style>
